import { useState } from "react";
import { toast } from "sonner";
import { PageHeader } from "@/components/layout/AppShell";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export default function Settings() {
  const { user, setUser, logout } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [bio, setBio] = useState(user?.bio || "");
  const save = async () => {
    try {
      const { data } = await api.put("/auth/profile", { name, bio });
      setUser(data);
      toast.success("Perfil actualizado");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div>
      <PageHeader eyebrow="Cuenta" title="Ajustes" subtitle="Tu perfil público de creador en el marketplace." />
      <div className="max-w-2xl space-y-6 px-6 py-10 lg:px-12">
        <div><label className="label">Email</label><input value={user?.email || ""} disabled className="field opacity-60" data-testid="settings-email" /></div>
        <div><label className="label">Nombre de creador</label><input value={name} onChange={(e) => setName(e.target.value)} className="field" data-testid="settings-name-input" /></div>
        <div><label className="label">Biografía</label><textarea value={bio} onChange={(e) => setBio(e.target.value)} rows={4} className="field" placeholder="Cuéntales a los compradores quién eres y en qué te especializas." data-testid="settings-bio-input" /></div>
        <div className="flex gap-3">
          <button onClick={save} className="btn-primary" data-testid="settings-save-button">Guardar cambios</button>
          <button onClick={logout} className="btn-ghost" data-testid="settings-logout-button">Cerrar sesión</button>
        </div>
      </div>
    </div>
  );
}
